module.exports = __webpack_public_path__ + "img/minimize.7b42904f.svg";